import {Injectable} from "@angular/core";
import {HttpService} from "./http.service";
import {HttpParams} from "@angular/common/http";
import {SubmitNewDocFormResponse} from "../models/submit-new-doc";
import {AddIntervenorResponse} from "../models/parties";
import {UtilService} from "./util.service";
import {TemplateService} from "./template.service";

@Injectable({
  providedIn: 'root'
})
export class SubmitNewDocService {

  constructor(private httpService: HttpService,
              private util: UtilService,
              private templateService: TemplateService) {
  }

  getSubmitNewDocForm(aNum: string) {
    const options = { headers: this.httpService.jsonHeaders };
    const url = '/submit-new-doc-form?aNum=' + aNum;

    return this.httpService.Post<SubmitNewDocFormResponse>(url,  new HttpParams(), options);
  }

  submitDocInfo(requestType: string, content?: string, docId?: number, protestId?: string, typeofdocument?: string, isDocConfidential?: string, comments?: string, docDescFiller?: string) {
    // check for curly quotes and replace with regular
    if (comments) comments = this.util.removeCurlyQuotes(comments);
    if (content) content = this.templateService.replaceChars(content);

    const formData = {
      content, docId, protestId, requestType, typeofdocument, isDocConfidential, comments, docDescFiller
    };

    const httpParams = this.httpService.createHttpParams(formData);
    const options = {headers: this.httpService.formHeaders};
    const url = '/add-attachments/other'

    return this.httpService.Post<AddIntervenorResponse>(url, httpParams, options);
  }

}
